/* all styles for the component variants go in this file */
import { font } from '@chegg-ui/theme';
import styled from 'styled-components';
import { getTooltipStyles, getTooltipPointerSpaceStyles } from './externals';
export var TooltipWrapper = styled.span.withConfig({
  componentId: "id17gq-0"
})(["position:relative;display:inline-block;"]);
export var TooltipPane = styled.div.withConfig({
  componentId: "id17gq-1"
})(["", ""], function (_ref) {
  var position = _ref.position,
      isShown = _ref.isShown,
      customTheme = _ref.customTheme;
  return getTooltipStyles(position, isShown, customTheme);
});
export var TooltipPointerSpace = styled.div.withConfig({
  componentId: "id17gq-2"
})(["", ""], function (_ref2) {
  var position = _ref2.position;
  return getTooltipPointerSpaceStyles(position);
});
/* export const TooltipCancelIconContainer = styled.div`
  position: relative;
  padding-left: 10px
`; */

export var TooltipTitle = styled.span.withConfig({
  componentId: "id17gq-3"
})(["font-size:", ";font-weight:", ";"], function (_ref3) {
  var customTheme = _ref3.customTheme;
  return customTheme.tooltipTitleFontSize;
}, font.weight.bold);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/tooltip/dist/esm/styles.js
// module id = 1497
// module chunks = 11